
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Grid from 'material-ui/Grid';
import contactImg from '../assets/imgContact-with-pin.png';

const styles = theme => ({
	contact: {
    paddingBottom: '50px',
  },
  contactImg: {
		background: 'url(' + contactImg + ') center',
    backgroundSize: 'cover',
    height: '400px',
	}
});

class Contact extends React.Component {

  render() {
  	const { classes } = this.props;
  	
    return (
    	<Grid container className={classes.contact} justify='center' alignItems='center' spacing={0}>
        <Grid item xs={12} className={classes.contactImg}></Grid>
        <Grid item xs={12} md={8} className='sectionText sectionText--top'>
          <h1>Contact Us</h1>
          <p>We'd like to hear from you. Please let us know how we can help.</p>
          <Grid container justify='center' alignItems='stretch'>
        		<Grid item xs={10} sm={5}>
              <h2>Mailing Address</h2>
              <div>
                Erich & Hannah Sachs Foundation<br />
                1000 4th Street, Suite 875<br />
                San Rafael, CA 94901
              </div>
            </Grid>
          </Grid>
        </Grid>  
        <Grid item xs={12} md={8} className='sectionText sectionText'>   
        <h2>Contacts</h2>     
          <Grid container justify='center' alignItems='stretch'>
            <Grid item xs={10} sm={5}>
              <h3>Caryn Sachs</h3>
              <div>+1.707.815.0140</div>
              <div>carynsachs@hotmail.com</div>
            </Grid>
            <Grid item xs={10} sm={5}>              
              <h3>Robert M. Long</h3>
              <div>+1.917.880.5725</div>
              <div>rlong@sachsfamilyfoundation.org</div>
            </Grid>
          </Grid>
        </Grid>
    	</Grid>
    );
  }
}

Contact.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Contact);


// WEBPACK FOOTER //
// ./src/views/Contact.js